import React from 'react';
import { Box, IconButton, Paper, Stack, Typography, Collapse } from '@mui/material';
import { UnfoldLess, UnfoldMore, DeleteOutlined } from '@mui/icons-material';
import { getHumanReadableDuration } from 'components/utils/displayDuration';

type Props = {
  position: number;
  title: string;
  duration: number;
  objectives: string;
  collapsed?: boolean;
  toggleCollapsed?: () => void;
  onDeleteModule: () => void;
  disableActions: boolean;
};

export function CourseModuleCard({
  position,
  title,
  duration,
  objectives,
  collapsed,
  toggleCollapsed,
  onDeleteModule,
  disableActions,
}: Props) {
  const showCollapseButton = toggleCollapsed !== undefined && collapsed !== undefined;

  return (
    <Paper variant='outlined' sx={{ bgcolor: 'background.default', borderRadius: 1, overflow: 'hidden' }}>
      <Box sx={{ display: 'grid', gridTemplateColumns: `56px 1fr`, gridTemplateRows: `1fr` }}>
        <Box sx={{ display: 'grid', placeContent: 'center', bgcolor: 'background.paper' }}>
          <Typography variant='labelLarge'>{position}</Typography>
        </Box>
        <Stack px={2} pt={1} pb={1}>
          <Stack direction='row' justifyContent='space-between' alignItems='center'>
            <Typography variant='titleSmall'>{title}</Typography>

            <Box display='flex' gap={1}>
              <IconButton
                data-testid='delete-module-button'
                disabled={disableActions}
                onClick={disableActions ? () => null : onDeleteModule}
                size='small'
              >
                <DeleteOutlined fontSize='small' />
              </IconButton>
              {showCollapseButton ? (
                <IconButton onClick={toggleCollapsed} size='small'>
                  {collapsed ? <UnfoldMore fontSize='small' /> : <UnfoldLess fontSize='small' />}
                </IconButton>
              ) : null}
            </Box>
          </Stack>
          <Collapse in={!collapsed} timeout='auto' unmountOnExit>
            <CourseModuleCardContent duration={duration} objectives={objectives} />
          </Collapse>
        </Stack>
      </Box>
    </Paper>
  );
}

function CourseModuleCardContent({ duration, objectives }: { duration: number; objectives: string }) {
  return (
    <Stack gap={2} pb={1}>
      <Typography variant='bodyMedium' color='text.secondary'>
        {getHumanReadableDuration(duration)}
      </Typography>

      <Typography variant='bodyMedium' sx={{ whiteSpace: 'pre-wrap' }}>
        {objectives}
      </Typography>
    </Stack>
  );
}
